import {
    AngleCutConfig, CurveCutConfig,
    DecorativeJoinType,
    getInitParam,
    InitParam,
    Line2,
    MPos,
    PlaceMeta,
    SegmentLine, SteppedCutConfig,
    Vec2
} from "@3dcalc/3dpClient";

const mapVec2: Vec2[] = []
const line2: Line2 = [[0,0],[0,0]]
const mapVec3:MPos[] = []
const segmentLines:SegmentLine[] = []
const placeMeta: PlaceMeta = {
    h: 0, l: 0, p: {b: [0,0], t: [0,0]}, w: 0
};


type ReadyCallback = () => void
const callbacks: ReadyCallback[] = []

export let IP: InitParam = { ...getInitParam() }
export let isReady = false

export function onReady(cb: ReadyCallback) {
    if (isReady) cb()  // уже готов — вызываем сразу
    else callbacks.push(cb)
}

export function setReady(config: InitParam) {
    Object.assign(IP, config)
    isReady = true
    callbacks.forEach(cb => cb())
    callbacks.length = 0
}

interface JoinSetting {
    type: DecorativeJoinType | null
    config: AngleCutConfig | SteppedCutConfig | CurveCutConfig | null
}

export const CP = {
    maps: {
        pillar: {
            line: mapVec2,
            map: mapVec3,
            lineCenteredCut: mapVec2,
            lineCut: mapVec2,
            lineCentered: mapVec2
        },
        f1: {
            lineCut: mapVec2,
        },
        harness: {
            segments: segmentLines,
        },
        f2: {
            param: placeMeta,
        },
        f3: {
            diagonal: line2,
        },
        f4: {
            point: [0, 0]
        },
        f6: {
            point: [0, 0]
        },
        rafter: {
            lineCut: mapVec2,
            map: mapVec2,
            hGash: 0,
            l: {
                left: 0,
                right: 0,
            },
            shiftBottom: {
                left: 0,
                right: 0,
            },
            hCut: 0,
            mapCentered: mapVec2
        }
    },
    materials: {
        harness: ['bc76418a-6997-47f2-bb50-179ca1f57c14', '8f01d3e5-7b33-4028-a9e1-0391a49cd530'],
        f1: ['bc76418a-6997-47f2-bb50-179ca1f57c14', '8f01d3e5-7b33-4028-a9e1-0391a49cd530'],
        rafters: ['8f01d3e5-7b33-4028-a9e1-0391a49cd530', '52908dda-d694-4d15-8bb3-e6393f043261', 'bc76418a-6997-47f2-bb50-179ca1f57c14']
    } as Record<string, string[]>,
    color: {

    },
    join: {
        rafters: { type: null, config: null } as JoinSetting,
        harness: { type: null, config: null } as JoinSetting,
    } as Record<string, JoinSetting>
}

export function initializate() {
    IP.gash.cut = IP.elementData.harness.sizeBoard.w - IP.elementData.pillar.sizeBoard.h / 2
}
